import { formatAddress, formatCurrencyNoDecimals } from '@if/core/utils'
import { ActionListItem, BodyText, type Action, type ActionListItemErrorProps } from '@if/mui'
import { Box, ListItemText, Tooltip } from '@mui/material'
import { ApplicantJob } from '@src/types/CreditApplicationSchema'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type Props = {
  onDelete?: () => void
  onEdit?: () => void
  data: ApplicantJob
  disableEdit: boolean
  toolTip: string
} & ActionListItemErrorProps

const DisplayJobInfosListItem = ({ onDelete, onEdit, data, disableEdit, toolTip, ...errorProps }: Props) => {
  const { address } = data
  const { t } = useTranslation()

  const actions: Action[] = [
    ...(onEdit ? [{ icon: Pencil, label: t('common.edit'), onClick: onEdit, disabled: disableEdit }] : []),
    ...(onDelete
      ? [
          {
            icon: Trash2,
            label: t('common.delete'),
            tone: 'destructive' as const,
            onClick: onDelete,
            disabled: disableEdit,
          },
        ]
      : []),
  ]

  return (
    <ActionListItem actions={actions} {...errorProps} disableGutters sx={{ pr: 10 }}>
      <Tooltip title={toolTip}>
        <ListItemText
          primary={
            <BodyText>{`${data.employerName} (${t(`EJobType.${data.jobType}`, { ns: 'enum' })}) : ${
              data.jobTitle
            } ${formatCurrencyNoDecimals(data.annualSalary)}`}</BodyText>
          }
          secondary={
            <>
              {formatAddress(address)}
              {errorProps.error && (
                <Box component="span" sx={{ display: 'block', color: 'error.main' }}>
                  {t('editCreditApplication.income.job.invalid')}
                </Box>
              )}
            </>
          }
        />
      </Tooltip>
    </ActionListItem>
  )
}

export default DisplayJobInfosListItem
